import { cn } from '@/lib/core/utils/cn';
import { Module } from './module';
import { RowElementModel } from '@/services/platform/api/model';
import { AppContext, RowItem } from '@/lib/core/types';

interface RowProps {
  row: RowItem;
  index?: number;
  context?: AppContext;
}

export function Row({ row, index: rowIndex, context }: RowProps) {
  if (!row.components.length) return null;

  const rowSettings = (row?.row?.content as RowElementModel)?.properties;

  return (
    <div
      className={cn('row', rowSettings?.fullWidth ? 'w-full' : 'container')}
      style={
        rowSettings?.backgroundColor
          ? { backgroundColor: rowSettings?.backgroundColor as unknown as string }
          : undefined
      }
    >
      {row.components.map((component, index) => {
        return (
          <Module
            key={index}
            item={component}
            index={index}
            context={context}
            extraProps={{ rowIndex: rowIndex }}
          />
        );
      })}
    </div>
  );
}
